import {
  KNOWN_STATUS_LABELS,
  ORDER_STATUS_TEXT_COLOR,
  ORDER_STATUS_TEXT_COLOR_FALLBACK,
  PROGRESOL_SCOPED_STATUS_LABELS,
  UNMAPPED_STATUS_PLACEHOLDER,
} from '@constants';
import { PalleteColor } from 'nanaykuna-ui-kit/loader';

export function equalsIgnoreCase(
  a?: string | null,
  b?: string | null,
): boolean {
  return (a ?? '').trim().toLowerCase() === (b ?? '').trim().toLowerCase();
}

export function getKnownStatusLabel(
  statusName: string | null | undefined,
  knownLabels: readonly string[],
  placeholder: string,
): string {
  if (
    !statusName ||
    !knownLabels.some(known => equalsIgnoreCase(known, statusName))
  ) {
    return placeholder;
  }
  return statusName;
}

export function getDisplayStatusLabel(
  statusName: string | null | undefined,
): string {
  return getKnownStatusLabel(
    statusName,
    KNOWN_STATUS_LABELS,
    UNMAPPED_STATUS_PLACEHOLDER,
  );
}

function normalizeStatus(statusName: string | null | undefined): string {
  return (statusName ?? '').trim().toLowerCase();
}

// Keys normalized once: these run per table row on every change-detection
// pass, so each call is a single Map lookup.
const STATUS_TEXT_COLOR_BY_KEY = new Map<string, PalleteColor>(
  Object.entries(ORDER_STATUS_TEXT_COLOR).map(([label, color]) => [
    normalizeStatus(label),
    color,
  ]),
);

const PROGRESOL_SCOPED_STATUS_KEYS = new Set(
  PROGRESOL_SCOPED_STATUS_LABELS.map(normalizeStatus),
);

// Same tolerance as getDisplayStatusLabel: the API's status casing and
// whitespace drift, so the lookup compares case-insensitively.
export function getStatusTextColor(
  statusName: string | null | undefined,
): PalleteColor {
  return (
    STATUS_TEXT_COLOR_BY_KEY.get(normalizeStatus(statusName)) ??
    ORDER_STATUS_TEXT_COLOR_FALLBACK
  );
}

// `data-brand` scope for a status cell: Aceptado keeps the Progresol blue.
export function getStatusBrand(
  statusName: string | null | undefined,
): 'progresol' | null {
  return PROGRESOL_SCOPED_STATUS_KEYS.has(normalizeStatus(statusName))
    ? 'progresol'
    : null;
}
